import React from 'react';
import { Container, Image } from 'semantic-ui-react';
import '../styles/sponsorsSection.scss';
import pmenaLogo from '../images/about2.png';
import clemsonLogo from '../images/clemson-logo.jpg';
import uscLogo from '../images/usc-logo.jpeg';

const SponsorsSection = (props) => (
  <div id="sponsors" className="content-deck sponsors">
      <div className="content-deck__headline">Sponsors</div>
      <Container>
            <Image alt='PMENA Conference Logo' centered className='logo' src={pmenaLogo}/>

            <div className='sponsor-logos'>
                <img alt='Clemson University Logo' className="sponsor__logo" src={clemsonLogo}/>
                <img alt='USC Logo' className="sponsor__logo" src={uscLogo}/>
            </div>
        </Container>
    </div>
);

export default SponsorsSection;



// WEBPACK FOOTER //
// ./src/sections/sponsorsSection.js